import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LenisProvider from "@/components/LenisProvider";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BatchCountdown from "@/components/BatchCountdown";
import Problem from "@/components/Problem";
import TurningPoint from "@/components/TurningPoint";
import WhatYouGet from "@/components/WhatYouGet";
import HowItWorks from "@/components/HowItWorks";
import BeforeAfter from "@/components/BeforeAfter";
import WhoFor from "@/components/WhoFor";
import Proof from "@/components/Proof";
import Offer from "@/components/Offer";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import LeadModal from "@/components/LeadModal";
import StickyCtas from "@/components/StickyCtas";
import Admin from "@/pages/Admin";
import ThankYou from "@/pages/ThankYou";

function Landing() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);

  return (
    <LenisProvider>
      <div className="bg-[#070A08] min-h-screen" data-testid="landing-page">
        <Navbar onBook={openModal} />
        <main>
          <Hero onBook={openModal} />
          <Marquee />
          <BatchCountdown onBook={openModal} />
          <Problem />
          <TurningPoint />
          <WhatYouGet />
          <HowItWorks onBook={openModal} />
          <BeforeAfter />
          <WhoFor />
          <Proof />
          <Offer onBook={openModal} />
          <Faq />
          <FinalCta onBook={openModal} />
        </main>
        <Footer />
        <StickyCtas onBook={openModal} />
        <LeadModal open={modalOpen} onClose={() => setModalOpen(false)} />
      </div>
    </LenisProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
